//import { Modal } from "antd";
import structuredClone from "@ungap/structured-clone";
import { Card } from "antd";
import Divider from "antd/lib/divider";
import CustomButton from "components/CustomButton/CustomButton";
import NotificheRepository from "core/data/NotificheRepository";
import { INotificheProps } from "pages/Notifiche/INotificheProps";
import { INotiticheUtente } from "core/interfaces/data/INotificheUtente";
import { selectNotification, setNotification } from "core/redux/features/notification/notificationSlice";
import { useAppSelector } from "core/redux/store/hooks";
import { useCallback, useEffect, useState } from "react";
import { FaArrowAltCircleDown, FaArrowAltCircleUp } from "react-icons/fa";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import { PagesEnum } from "types/PagesEnum";
import { personalAreaStep } from "types/StepEnums";
import i18n from "utils/i18n";
import NavigationManager from "utils/NavigationManager";
import useWindowDimensions from "utils/WindowSize";

import "./Notifiche.css";
import { Enhanced } from "utils/ReactUtils";

const Notifiche: React.FC<INotificheProps> = ({dispatch,t,sessionInfo}) => {
	
	const notification = useAppSelector(selectNotification);
	const { GoToPage } = NavigationManager(sessionInfo);

	const { width } = useWindowDimensions();

	const [idNotificaCurrent, setIdNotificaCurrent] = useState<number | undefined>(-1);
	const [maxWordLenght, setMaxWordLenght] = useState<number>(100);



	const setNotifiche = (notifiche: Array<INotiticheUtente>) => {
		dispatch(setNotification(notifiche));
	};
	const extendMessage = (index: number) => {
		let corrente = notification.notications[index];

		(async (ix) => {
			var n = structuredClone(notification.notications);
			let notificaCorrente = n[ix];
			let res = await NotificheRepository.SetNotificaRead({
				IdNotifica: notificaCorrente.IdNotification,
				IdSessione: sessionInfo.sessione?.idSessione,
				culture: i18n.language,
			});
			if (res) {
				notificaCorrente.Letto = res;

				n[ix] = notificaCorrente;
				setNotifiche(n);
			}
		})(index);

		if (corrente.IdNotification === idNotificaCurrent) setIdNotificaCurrent(undefined);
		else setIdNotificaCurrent(corrente.IdNotification);
	};

	const resizeFunction = useCallback(() => {
		setMaxWordLenght(Math.floor(width / 45) * 5);
	}, [width]);

	useEffect(() => {
		resizeFunction();
	}, [resizeFunction]);

	const GoToPersonalArea = () => {
		GoToPage(PagesEnum.PersonalArea, personalAreaStep.datiUtente);
	};

	return (
		<>
			<div id="notifiche" className="elanco-notifiche-body">
				<div className="elanco-notifiche-header"></div>
				<div className="elanco-notifiche-content">
					{(notification?.notications?.length ?? 0) === 0 && (
						<div className="text">
							<span>{t("notifiche.notificaAssente")} </span>
						</div>
					)}
					{notification.notications.map((notifica, index) => {
						return (
							<div key={index}>
								<div key={index + "|" + notifica.Letto} className={`notifica-${notifica.Letto ? "letta" : "non-letta"}`}>
									<div className="side-space">&nbsp;</div>
									<div className="content">
										<Card
											onClick={() => extendMessage(index)}
											className="cardNotifica"
											title={
												<>
													<span>
														<b>{notifica?.Title} </b>
													</span>
													<span>{notifica?.DateNotification.toFormattedDateString("DD/MM/yyy HH:mm")}</span>
												</>
											}
											extra={idNotificaCurrent !== notifica.IdNotification ? <FaArrowAltCircleDown /> : <FaArrowAltCircleUp />}
										>
											<span>
												{idNotificaCurrent !== notifica.IdNotification && notifica?.Body.length > maxWordLenght
													? notifica?.Body.substring(0, maxWordLenght - 3) + "..."
													: notifica?.Body}
											</span>
										</Card>
									</div>
								</div>
								<Divider style={{ margin: 0 }} />
							</div>
						);
					})}
					<div className="buttonContainer">
						<CustomButton buttonType={CustomButtonType.negative} text={t("notifiche.goBack")} OnClick={GoToPersonalArea} />
					</div>
				</div>
			</div>
		</>
	);
};

export default Enhanced(Notifiche,{componentNamespace:"Notifiche"});
